"use client";

import React, { useEffect, useRef } from "react";

import Link from "next/link";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HowItsMadeSection from "@/app/homepage/components/HowItsMadeSection";

export default function OurStoryPage() {
  const pageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0 }
    );
    pageRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <>
      <Header />
      <main ref={pageRef} className="bg-pmu-cream min-h-screen pt-24">
        {/* Origin Story */}
        <section className="section-pad bg-pmu-cream">
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
            <div className="reveal-hidden">
              <p className="text-xs font-medium uppercase tracking-widest text-pmu-taupe mb-6" style={{ letterSpacing: "0.2em" }}>
                Where It All Began
              </p>
              <h2 className="font-fraunces font-bold text-pmu-espresso mb-8" style={{ fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)" }}>Because sometimes all you need is a Pick Me Up

              </h2>
            </div>
            <div className="reveal-hidden delay-1 space-y-6 text-pmu-taupe leading-relaxed" style={{ fontSize: "1.0625rem" }}>
              <p>Pick Me Up started with a dream to create a community that supports everyone to live happy and naturally. In a time where it is common to see people lonely and digesting foods wrapped in chemicals, we created a community space encouraging you to be your best self and offering clean nutrition. So, when you need a Pick Me Up we are here.



              </p>
              <p>Starting with our organic coffee café in the old port of Montréal, we built a space and community that truly became a 'pick me up' for so many people. Like us, we found out that so many face daily struggles to find snacks, not only with clean ingredients, but ones that aren't empty calories and instead offer nourishing benefits like extra protein.  And so, our Pick Me Up cookie was introduced. 



              </p>
              <p>And while you may already have everything you need, sometimes you really just need a Pick Me Up.


              </p>
            </div>
            <div className="reveal-hidden delay-2 mt-10">
              <div className="overflow-hidden rounded-2xl" style={{ maxHeight: "480px" }}>
                <img
                  src="/assets/images/Screen_Shot_2026-04-02_at_1.17.14_PM-1775569734308.png"
                  alt="Pick Me Up origins — the café and community in the old port of Montréal"
                  className="w-full object-cover object-center"
                  style={{ filter: "grayscale(100%)", height: "480px", objectPosition: "center 40%" }}
                />
              </div>
            </div>
          </div>
        </section>
        {/* Values */}
        <section className="section-pad bg-pmu-warm">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="reveal-hidden text-center mb-14">
              <p className="text-xs font-medium uppercase tracking-widest text-pmu-taupe mb-4" style={{ letterSpacing: "0.2em" }}>
                What We Stand For
              </p>
              <h2 className="font-fraunces font-bold text-pmu-espresso" style={{ fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)" }}>
                Our values
              </h2>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {[
              {
                title: "Community",
                body: "We believe community fulfills the fundamental human need for belonging, connection, and safety.  "
              },
              {
                title: "Positive Spirit",
                body: "A positive spirit is contagious motivation. It's not just important for your mental and physical health, but as a key to achieve your goals and be your best self."
              },
              {
                title: "Clean Nutrition",
                body: "No fillers, no artificial flavours. Every ingredient earns its place in our recipe. We believe you deserve to know exactly what you&apos;re eating."
              }]?.
              map(({ title, body }) =>
              <div
                key={title}
                className="reveal-hidden delay-1 p-8 rounded-3xl"
                style={{ background: "#FFFFFF", border: "1px solid rgba(214, 207, 196, 0.5)" }}>

                  <h3 className="font-fraunces font-semibold text-pmu-espresso text-xl mb-3">{title}</h3>
                  <p className="text-pmu-taupe leading-relaxed" dangerouslySetInnerHTML={{ __html: body }} />
                </div>
              )}
            </div>
          </div>
        </section>
        {/* How It's Made */}
        <HowItsMadeSection />
        {/* CTA */}
        <section className="section-pad bg-pmu-cream">
          <div className="max-w-2xl mx-auto px-6 text-center">
            <div className="reveal-hidden">
              <h2 className="font-fraunces font-bold text-pmu-espresso mb-6" style={{ fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)" }}>
                Ready to taste the difference?
              </h2>
              <p className="text-pmu-taupe mb-8 leading-relaxed">Join the growing community who want to be their best selves — both mentally and physically.

              </p>
              <Link href="/purchase" className="btn-primary">
                Shop Now
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>);

}